var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_212)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#36D66B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0944 29.0711C26.8228 31.3427 22.0054 33.3067 18.0956 30.8906C17.878 30.7561 17.7693 30.6889 17.687 30.6563C17.5297 30.594 17.4104 30.576 17.2418 30.589C17.1536 30.5958 17.0536 30.6217 16.8537 30.6736C15.5959 30.9996 14.967 31.1626 14.514 31.0704C13.7276 30.9103 13.113 30.2958 12.953 29.5094C12.8608 29.0563 13.0238 28.4274 13.3498 27.1696C13.4016 26.9697 13.4275 26.8697 13.4343 26.7812C13.4473 26.6126 13.4289 26.4919 13.3663 26.3347C13.3334 26.2523 13.2663 26.1442 13.132 25.9282C10.7076 22.0269 12.5839 17.2973 14.9523 14.9289C18.8575 11.0237 25.1892 11.0237 29.0944 14.9289C32.9997 18.8342 32.9997 25.1658 29.0944 29.0711Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0527 21.8574C19.0527 22.4097 18.605 22.8574 18.0527 22.8574C17.5004 22.8574 17.0527 22.4097 17.0527 21.8574C17.0527 21.3051 17.5004 20.8574 18.0527 20.8574C18.605 20.8574 19.0527 21.3051 19.0527 21.8574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0527 21.8574C23.0527 22.4097 22.605 22.8574 22.0527 22.8574C21.5004 22.8574 21.0527 22.4097 21.0527 21.8574C21.0527 21.3051 21.5004 20.8574 22.0527 20.8574C22.605 20.8574 23.0527 21.3051 23.0527 21.8574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0527 21.8574C27.0527 22.4097 26.605 22.8574 26.0527 22.8574C25.5005 22.8574 25.0527 22.4097 25.0527 21.8574C25.0527 21.3051 25.5005 20.8574 26.0527 20.8574C26.605 20.8574 27.0527 21.3051 27.0527 21.8574Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportActive);
export default __webpack_public_path__ + "static/media/supportActive.55647e890ffab34ac98e51e307d04c98.svg";
export { ForwardRef as ReactComponent };